// extracted by mini-css-extract-plugin
export default {"container":"OurVisionList_container__HmwC9","img":"OurVisionList_img__PE4rA","title":"OurVisionList_title__gYvNd","text":"OurVisionList_text__zsdRP"};